// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","iphone5":"screen and (max-width: 320px)","container":"container-2Xyhj"};